import { render, staticRenderFns } from "./WorkerList.vue?vue&type=template&id=4963a286&scoped=true"
import script from "./WorkerList.vue?vue&type=script&lang=js"
export * from "./WorkerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4963a286",
  null
  
)

export default component.exports